import { logToAnalytics } from 'modules'

import { type HotspotElementType } from 'app/types'

// Playback-side hotspot (interactive demo) events. Event names match the producer tracker so both
// surfaces report into the same Mixpanel events. The `source` ('embed') is attached globally in
// modules/analytics, so it's included automatically here.

type HotspotClickedProps = {
    playbookId: string
    action?: 'nextStep' | 'goToStep'
    // Which element the viewer clicked — lets engagement be sliced per hotspot type, matching the
    // producer player. Absent on layers authored before the area/callout types shipped.
    elementType?: HotspotElementType
}

export const HotspotAnalytics = {
    clicked(props: HotspotClickedProps): void {
        logToAnalytics('hotspot_clicked', props)
    },
}
